export const categories = [
  {
    id: 'love',
    name: '恋爱',
    slug: 'love',
    icon: 'ri-heart-line',
    description: '甜蜜浪漫的恋爱故事，少女心爆棚的纯爱韩漫',
    count: 326,
  },
  {
    id: 'action',
    name: '动作',
    slug: 'action',
    icon: 'ri-sword-line',
    description: '热血沸腾的战斗场面，肾上腺素飙升的爽漫',
    count: 258,
  },
  {
    id: 'fantasy',
    name: '奇幻',
    slug: 'fantasy',
    icon: 'ri-magic-line',
    description: '穿越重生异世界，奇幻冒险尽在其中',
    count: 412,
  },
  {
    id: 'suspense',
    name: '悬疑',
    slug: 'suspense',
    icon: 'ri-search-eye-line',
    description: '扣人心弦的悬疑推理，烧脑刺激的剧情',
    count: 187,
  },
  {
    id: 'comedy',
    name: '喜剧',
    slug: 'comedy',
    icon: 'ri-emotion-laugh-line',
    description: '轻松搞笑的日常故事，笑到停不下来',
    count: 145,
  },
  {
    id: 'horror',
    name: '恐怖',
    slug: 'horror',
    icon: 'ri-ghost-line',
    description: '毛骨悚然的恐怖故事，胆小慎入',
    count: 93,
  },
  {
    id: 'daily',
    name: '日常',
    slug: 'daily',
    icon: 'ri-sun-line',
    description: '温馨治愈的日常生活，平凡中的感动',
    count: 201,
  },
  {
    id: 'bl',
    name: 'BL',
    slug: 'bl',
    icon: 'ri-heart-2-line',
    description: '人气BL韩漫，唯美动人的故事',
    count: 178,
  },
];

export const categoryComicsMap: Record<string, number[]> = {
  love: [1, 3, 5, 9],
  action: [2, 4, 8],
  fantasy: [6, 7, 11],
  suspense: [10, 12],
  comedy: [5, 9],
  horror: [10],
  daily: [7],
  bl: [3],
};